import { get, post, del } from 'aws-amplify/api';
import { Application } from '../models/application.model';
import { CreateApplication, CreateApplicationSchema } from '../models/createApplication.model';
import { format, sub, addDays } from 'date-fns';
import { getUserToken } from './util.service';

export const createApplication = async (createApplication: Application) => {
  const createApplicationBody = mapToRequest(createApplication);
  const response = await post({
    apiName: "applications",
    path: "/applications",
    options: { body: createApplicationBody as any },
  }).response;
  const json = (await response.body.json()) as any;
  return mapFromResponse(json);
};

export const getApplications = async (filters: {
  startDate?: string;
  endDate: string;
  name?: string;
  archived?: boolean;
  isPhoneApplication?: boolean;
}): Promise<Application[]> => {
  let { startDate, endDate, name, archived, isPhoneApplication } = filters;

  if (!startDate) startDate = format(sub(new Date(), { years: 1 }), "yyyy-MM-dd");
  if (!endDate) endDate = format(addDays(new Date(), 1), "yyyy-MM-dd");

  const response = await get({
    apiName: "applications",
    path: `/applications?startDate=${startDate}&endDate=${endDate}&name=${name}&archived=${archived}&isPhoneApplication=${isPhoneApplication}`,
  }).response;
  const json = (await response.body.json()) as any;
  return json.map((a: any) => mapFromResponse(a));
};

export const getApplication = async (applicationId: string): Promise<Application> => {
  const userToken = await getUserToken();
  const response = await get({
    apiName: "applications",
    path: `/applications/${applicationId}`,
    options: { headers: { "x-auth-token": `Bearer ${userToken}` } },
  }).response;
  const json = (await response.body.json()) as any;
  return mapFromResponse(json);
};

export const deleteApplication = async (applicationId: string): Promise<void> => {
  await del({ apiName: "applications", path: `/applications/${applicationId}` }).response;
};

export const archiveApplication = async (applicationId: string): Promise<void> => {
  await post({ apiName: "applications", path: `/applications/${applicationId}/archive` }).response;
};

export const unarchiveApplication = async (applicationId: string): Promise<void> => {
  await post({ apiName: "applications", path: `/applications/${applicationId}/unarchive` }).response;
};

const mapFromResponse = (app: any): Application => {
  const res: Application = {
    ...app,
    createdAt: new Date(app.createdAt),
    updatedAt: app.updatedAt ? new Date(app.updatedAt) : undefined,
  };
  return res;
};

export class ValidationError extends Error {
  constructor(message: string, public errors: string[]) {
    super(message);
    this.name = "ValidationError";
  }
}

const mapToRequest = (app: Application): CreateApplication => {
  const resParse = CreateApplicationSchema.safeParse(app);
  if (resParse.success) {
    return resParse.data;
  }

  // console.log(resParse.error);
  // ZodError: [
  //   {
  //     code: "too_big",
  //     maximum: 11,
  //     type: "number",
  //     inclusive: true,
  //     exact: false,
  //     message: "Number must be less than or equal to 11",
  //     path: ["previousMonthsAtAddress"],
  //   },
  //   {
  //     code: "too_big",
  //     maximum: 11,
  //     type: "number",
  //     inclusive: true,
  //     exact: false,
  //     message: "Number must be less than or equal to 11",
  //     path: ["coapplicantPreviousEmployedMonths"],
  //   },
  // ];
  const errorMessages = resParse.error.issues.map((error) => `${String(error.path[0])}: ${error.message}`);
  throw new ValidationError("Validation error", errorMessages);
};
